/**
 * Ordering helpers for the auto-execution ledger.
 *
 * A standalone module with no arriere-client import so it can be unit-tested
 * without dragging the generated client into the test runtime.
 */

/**
 * Compares two `eventNo` ledger sequences, newest first.
 *
 * `eventNo` is a Postgres bigint serialized as a string, and both obvious
 * approaches are wrong: `Number()` silently loses precision past 2^53, and a
 * plain string compare puts `"9"` after `"10"`. Comparing digit count first,
 * then lexically, is exact for arbitrarily large values.
 *
 * This is the only correct sort key for history. `occurredAt` ties for
 * everything written inside one transaction, so ordering by it shuffles rows
 * that fired in a single dispatcher drain.
 */
export function compareEventNoDesc(a: string, b: string): number {
  const aDigits = a.replace(/^0+/, '')
  const bDigits = b.replace(/^0+/, '')
  if (aDigits.length !== bDigits.length) return bDigits.length - aDigits.length
  return bDigits.localeCompare(aDigits)
}
